import { render } from "./MemoruSales.vue?vue&type=template&id=0b5b45d4&ts=true"
import script from "./MemoruSales.vue?vue&type=script&lang=ts"
export * from "./MemoruSales.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__